import React from 'react';
import styled from 'styled-components';
import HasRole from 'components/HasRole';
import { WRITE_ACCESS_AUTH_ROLES } from 'utils/appConstants';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const Header = styled.p`
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 10px;

  flex: 1 1 100%;
`;

const AddRelations = ({ children, title, ...props }) => {
  return (
    <Container>
      <Header>{title}</Header>
      {children}
    </Container>
  );
};

const AddRelationsContainer = HasRole(AddRelations, WRITE_ACCESS_AUTH_ROLES);

export default AddRelationsContainer;
